<template lang="">
    <div class="maskPop" @click.stop="onClose"  v-if="show">
         <slot></slot>
    </div>
</template>
<script>
export default {
    props:["show"],
    mounted(){
       
    },
    watch:{
        show(a){
             var body = document.getElementsByTagName("body")[0];
            if(a){
                body.style.overflow="hidden";
            }else{
                body.style.overflow="";
            }
        }
    },
    methods:{
        onClose(){
            this.$emit("onClose")
        },

    }
}
</script>
<style lang="scss">
    .maskPop{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background:rgba(0,0,0,.4);
    }
</style>